import { Component } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { TipsReport, TipsReportItem } from '../../models/reports.model';
import { pageNameToPath, ReportsPages, reportsPages, ReportsTipsTab, reportsTipsTab } from '../../models/navigation.model';
import { map } from 'rxjs/operators';
import { NavigationService } from '../../services/navigation.service';
import { ReportsService } from '../../services/reports.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalsService } from 'projects/common/src/lib/services/modals.service';
import { ViewAsService } from '../../services/view-as.service';
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { DateFilter } from '../../models/date-filter.model';
import { ConfirmationDialog } from 'projects/common/src/lib/modals/confirmation-dialog/confirmation-dialog.component';
import { showSnackbar } from 'projects/common/src/lib/components/snackbar/snackbar.component';

@Component({
  selector: 'app-reports-tips',
  templateUrl: './reports-tips.component.html',
  styleUrls: ['./reports-tips.component.scss']
})
export class ReportsTipsComponent {
  report$: Observable<TipsReport> = this.reportsService.report$ as Observable<TipsReport>;
  loading$ = this.reportsService.loading$;
  dateFilter$ = this.reportsService.selectedDateRangeForEvent$;
  readonly$ = this.viewAsService.readonly$;

  tabs = Array.from(reportsTipsTab);
  pages = Array.from(reportsPages);

  nav$ = combineLatest([
    this.navigationService.page$,
    this.navigationService.tab$
  ]).pipe(
    map(([page, tab]) => {
      return {
        page,
        tab
      };
    })
  );

  get selectedTips() {
    return this.reportsService.selectedTips;
  }

  constructor(
    private navigationService: NavigationService,
    private reportsService: ReportsService,
    private route: ActivatedRoute,
    private router: Router,
    private modalsService: ModalsService,
    private viewAsService: ViewAsService,
    private snackbar: MatSnackBar,
  ) { }

  onTabSelected(tab: string) {
    const page = pageNameToPath(tab as ReportsTipsTab);
    this.reportsService.selectedTips.clear();
    this.router.navigate([page], { relativeTo: this.route });
  }

  onPageSelected(page: string) {
    const chosenPage = pageNameToPath(page as ReportsPages);
    this.reportsService.selectedTips.clear();
    this.router.navigateByUrl('reports/' + [chosenPage]);
  }

  selectedRangeChange(event: [Date, Date] | null) {
    this.reportsService.setSelectedDateRange(event ? DateFilter.from(event) : null);
  }

  async markAsPaid() {
    const sum = (await this.reportsService.sumSelectedTips()).toFixed(2);
    await this.modalsService.open(ConfirmationDialog, {
      data: {
        title: `Mark as Paid`,
        message: `Are you sure you want to mark $${sum} as paid?`,
        cancelTitle: 'No',
        actionTitle: 'Yes',
        action: async () => {
          await this.reportsService.mark('tips');

          showSnackbar(this.snackbar, {
            message: `Tip Paid`,
            duration: 2000,
          });
        },
        actionColor: 'primary',
      }
    });
  }

  getSelectedTab(selectedTab: string | null) {
    if (selectedTab)
      return selectedTab === 'Pending' ? 'tipsPending' : 'tipsPaid';
    return '';
  }

  ngOnDestroy() {
    this.reportsService.selectedTips.clear();
  }

  checkAllSelected(checked: boolean, allIds: TipsReportItem[]) {
    this.reportsService.selectedTips = checked
      ? new Set<TipsReportItem>(allIds)
      : new Set<TipsReportItem>();
  }

  isAllSelected(allIds: TipsReportItem[]) {
    const selected = Array.from(this.selectedTips);
    return allIds.length > 0 && allIds.length === this.selectedTips.size
      && allIds.every((x) => selected.some((y) => y.paymentId === x.paymentId && y.wId === x.wId && y.userId === x.userId));
  }
}
